<div class="div-arriere-plan-action" (click)="onDismiss(false)"></div>
<div class="div-global-action" style="text-align: center;" (click)="$event.stopPropagation()">
  <div id="center-square">
    <h1 *ngIf="voters.length == 0" class="text-lg dark-blue no-margin">Confirmer la suppression de cet électeur</h1>
    <h1 *ngIf="voters.length > 0" class="text-lg dark-blue no-margin">Confirmer la suppression de ces {{voters.length}} électeurs</h1>

    <div *ngIf="voters.length > 0" class="mt-30 mb-30" style="max-height: 100px; overflow-y: scroll;">
      <p *ngFor="let voter of voters; let i = index" class="dark-blue no-margin pb-10 pt-10" [class.bg-light-gray]="i % 2 === 0">{{ voter.firstName }} {{ voter.lastName }} {{voter.college}}</p>
    </div>

    <div class="flex content-center gap-10">
      <!-- <button (click)="onDismiss(true)">Oui, je supprime</button>
      <button (click)="onDismiss(false)">Non, j'annule</button> -->

      <v8te-active-button [buttonText]="'Non, j\'annule'" [primaryColor]="'#ffffff'" [secondaryColor]="'#FFECEC'"
        [textPrimaryColor]="'#2B2D67'" [textSecondaryColor]="'#EF4444'" [border]="'solid 1px #D9D9D9'" (click)="onDismiss(false)"
        [height]="'40px'" [minWidth]="'120px'" [width]="'120px'" [bold]="'true'"></v8te-active-button>

      <v8te-active-button [buttonText]="'Oui, je supprime'" [primaryColor]="'#EF4444'" [secondaryColor]="'#FFECEC'"
        [textPrimaryColor]="'#ffffff'" [textSecondaryColor]="'#EF4444'" [border]="'none'" (click)="onDismiss(true)"
        [height]="'40px'" [minWidth]="'120px'" [width]="'120px'" [bold]="'true'"></v8te-active-button>
    </div>

  </div>
</div>